import React from "react";
import { types } from "mobx-state-tree";
import { EllipseComponent, EllipseDrawingTool, EllipseObject } from "../objects/ellipse";
import { ImageComponent, ImageObject, StampDrawingTool } from "../objects/image";
import { LineComponent, LineDrawingTool, LineObject } from "../objects/line";
import { RectangleComponent, RectangleDrawingTool, RectangleObject } from "../objects/rectangle";
import { VectorComponent, VectorDrawingTool, VectorObject } from "../objects/vector";
import { SelectionDrawingTool } from "./selection-drawing-tool";
import { TextComponent, TextDrawingTool, TextObject } from "../objects/text";
const gDrawingObjectInfos = {
    line: {
        type: "line",
        component: LineComponent,
        modelClass: LineObject,
    },
    vector: {
        type: "vector",
        component: VectorComponent,
        modelClass: VectorObject,
    },
    rectangle: {
        type: "rectangle",
        component: RectangleComponent,
        modelClass: RectangleObject,
    },
    ellipse: {
        type: "ellipse",
        component: EllipseComponent,
        modelClass: EllipseObject,
    },
    text: {
        type: "text",
        component: TextComponent,
        modelClass: TextObject,
    },
    image: {
        type: "image",
        component: ImageComponent,
        modelClass: ImageObject,
    }
};
const gDrawingToolInfos = {
    select: {
        name: "select",
        toolClass: SelectionDrawingTool
    },
    line: {
        name: "line",
        toolClass: LineDrawingTool
    },
    vector: {
        name: "vector",
        toolClass: VectorDrawingTool,
    },
    rectangle: {
        name: "rectangle",
        toolClass: RectangleDrawingTool
    },
    ellipse: {
        name: "ellipse",
        toolClass: EllipseDrawingTool
    },
    text: {
        name: "text",
        toolClass: TextDrawingTool
    },
    stamp: {
        name: "stamp",
        toolClass: StampDrawingTool
    },
    duplicate: {
        name: "duplicate"
    },
    delete: {
        name: "delete"
    }
};
export function getDrawingToolInfos() {
    return Object.values(gDrawingToolInfos).filter(value => value);
}
export function getDrawingObjectInfos() {
    return Object.values(gDrawingObjectInfos).filter(value => value);
}
export function getDrawingObjectComponent(drawingObject) {
    const info = gDrawingObjectInfos[drawingObject.type];
    return info === null || info === void 0 ? void 0 : info.component;
}
export function registerDrawingObjectInfo(drawingObjectInfo) {
    gDrawingObjectInfos[drawingObjectInfo.type] = drawingObjectInfo;
}
export function registerDrawingToolInfo(drawingToolInfo) {
    gDrawingToolInfos[drawingToolInfo.name] = drawingToolInfo;
}
export function renderDrawingObject(drawingObject, readOnly = false, handleHover, handleDrag, a11yProps) {
    const DrawingObjectComponent = getDrawingObjectComponent(drawingObject);
    if (!DrawingObjectComponent)
        return null;
    const element = (React.createElement(DrawingObjectComponent, { key: drawingObject.id, model: drawingObject, readOnly: readOnly, handleHover: handleHover, handleDrag: handleDrag, a11yProps: a11yProps }));
    if (drawingObject.visible) {
        return element;
    }
    else {
        // invisible objects, when rendered, are rendered as 'ghosts'
        return (React.createElement("g", { key: drawingObject.id, className: "ghost" }, element));
    }
}
export const DrawingObjectMSTUnion = types.late(() => {
    const drawingObjectModels = Object.values(gDrawingObjectInfos).map(info => info.modelClass);
    return types.union(...drawingObjectModels);
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZHJhd2luZy1vYmplY3QtbWFuYWdlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9wbHVnaW5zL2RyYXdpbmcvY29tcG9uZW50cy9kcmF3aW5nLW9iamVjdC1tYW5hZ2VyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEtBQUssTUFBTSxPQUFPLENBQUM7QUFDMUIsT0FBTyxFQUFFLEtBQUssRUFBRSxNQUFNLGlCQUFpQixDQUFDO0FBSXhDLE9BQU8sRUFBRSxnQkFBZ0IsRUFBRSxrQkFBa0IsRUFBRSxhQUFhLEVBQUUsTUFBTSxvQkFBb0IsQ0FBQztBQUN6RixPQUFPLEVBQUUsY0FBYyxFQUFFLFdBQVcsRUFBRSxnQkFBZ0IsRUFBRSxNQUFNLGtCQUFrQixDQUFDO0FBQ2pGLE9BQU8sRUFBRSxhQUFhLEVBQUUsZUFBZSxFQUFFLFVBQVUsRUFBRSxNQUFNLGlCQUFpQixDQUFDO0FBQzdFLE9BQU8sRUFBRSxrQkFBa0IsRUFBRSxvQkFBb0IsRUFBRSxlQUFlLEVBQUMsTUFBTSxzQkFBc0IsQ0FBQztBQUNoRyxPQUFPLEVBQUUsZUFBZSxFQUFFLGlCQUFpQixFQUFFLFlBQVksRUFBRSxNQUFNLG1CQUFtQixDQUFDO0FBQ3JGLE9BQU8sRUFBRSxvQkFBb0IsRUFBRSxNQUFNLDBCQUEwQixDQUFDO0FBQ2hFLE9BQU8sRUFBRSxhQUFhLEVBQUUsZUFBZSxFQUFFLFVBQVUsRUFBRSxNQUFNLGlCQUFpQixDQUFDO0FBZTdFLE1BQU0sbUJBQW1CLEdBQW1EO0lBQzFFLElBQUksRUFBRTtRQUNKLElBQUksRUFBRSxNQUFNO1FBQ1osU0FBUyxFQUFFLGFBQWE7UUFDeEIsVUFBVSxFQUFFLFVBQVU7S0FDdkI7SUFDRCxNQUFNLEVBQUU7UUFDTixJQUFJLEVBQUUsUUFBUTtRQUNkLFNBQVMsRUFBRSxlQUFlO1FBQzFCLFVBQVUsRUFBRSxZQUFZO0tBQ3pCO0lBQ0QsU0FBUyxFQUFFO1FBQ1QsSUFBSSxFQUFFLFdBQVc7UUFDakIsU0FBUyxFQUFFLGtCQUFrQjtRQUM3QixVQUFVLEVBQUUsZUFBZTtLQUM1QjtJQUNELE9BQU8sRUFBRTtRQUNQLElBQUksRUFBRSxTQUFTO1FBQ2YsU0FBUyxFQUFFLGdCQUFnQjtRQUMzQixVQUFVLEVBQUUsYUFBYTtLQUMxQjtJQUNELElBQUksRUFBRTtRQUNKLElBQUksRUFBRSxNQUFNO1FBQ1osU0FBUyxFQUFFLGFBQWE7UUFDeEIsVUFBVSxFQUFFLFVBQVU7S0FDdkI7SUFDRCxLQUFLLEVBQUU7UUFDTCxJQUFJLEVBQUUsT0FBTztRQUNiLFNBQVMsRUFBRSxjQUFjO1FBQ3pCLFVBQVUsRUFBRSxXQUFXO0tBQ3hCO0NBQ0YsQ0FBQztBQUVGLE1BQU0saUJBQWlCLEdBQWlEO0lBQ3RFLE1BQU0sRUFBRTtRQUNOLElBQUksRUFBRSxRQUFRO1FBQ2QsU0FBUyxFQUFFLG9CQUFvQjtLQUNoQztJQUNELElBQUksRUFBRTtRQUNKLElBQUksRUFBRSxNQUFNO1FBQ1osU0FBUyxFQUFFLGVBQWU7S0FDM0I7SUFDRCxNQUFNLEVBQUU7UUFDTixJQUFJLEVBQUUsUUFBUTtRQUNkLFNBQVMsRUFBRSxpQkFBaUI7S0FDN0I7SUFDRCxTQUFTLEVBQUU7UUFDVCxJQUFJLEVBQUUsV0FBVztRQUNqQixTQUFTLEVBQUUsb0JBQW9CO0tBQ2hDO0lBQ0QsT0FBTyxFQUFFO1FBQ1AsSUFBSSxFQUFFLFNBQVM7UUFDZixTQUFTLEVBQUUsa0JBQWtCO0tBQzlCO0lBQ0QsSUFBSSxFQUFFO1FBQ0osSUFBSSxFQUFFLE1BQU07UUFDWixTQUFTLEVBQUUsZUFBZTtLQUMzQjtJQUNELEtBQUssRUFBRTtRQUNMLElBQUksRUFBRSxPQUFPO1FBQ2IsU0FBUyxFQUFFLGdCQUFnQjtLQUM1QjtJQUNELFNBQVMsRUFBRTtRQUNULElBQUksRUFBRSxXQUFXO0tBQ2xCO0lBQ0QsTUFBTSxFQUFFO1FBQ04sSUFBSSxFQUFFLFFBQVE7S0FDZjtDQUNGLENBQUM7QUFFRixNQUFNLFVBQVUsbUJBQW1CO0lBQ2pDLE9BQU8sTUFBTSxDQUFDLE1BQU0sQ0FBQyxpQkFBaUIsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsRUFBRSxDQUFDLEtBQUssQ0FBdUIsQ0FBQztBQUN2RixDQUFDO0FBRUQsTUFBTSxVQUFVLHFCQUFxQjtJQUNuQyxPQUFPLE1BQU0sQ0FBQyxNQUFNLENBQUMsbUJBQW1CLENBQUMsQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLEVBQUUsQ0FBQyxLQUFLLENBQXlCLENBQUM7QUFDM0YsQ0FBQztBQUVELE1BQU0sVUFBVSx5QkFBeUIsQ0FBQyxhQUFnQztJQUN4RSxNQUFNLElBQUksR0FBRyxtQkFBbUIsQ0FBQyxhQUFhLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDckQsT0FBTyxJQUFJLGFBQUosSUFBSSx1QkFBSixJQUFJLENBQUUsU0FBUyxDQUFDO0FBQ3pCLENBQUM7QUFFRCxNQUFNLFVBQVUseUJBQXlCLENBQUMsaUJBQXFDO0lBQzdFLG1CQUFtQixDQUFDLGlCQUFpQixDQUFDLElBQUksQ0FBQyxHQUFHLGlCQUFpQixDQUFDO0FBQ2xFLENBQUM7QUFFRCxNQUFNLFVBQVUsdUJBQXVCLENBQUMsZUFBaUM7SUFDdkUsaUJBQWlCLENBQUMsZUFBZSxDQUFDLElBQUksQ0FBQyxHQUFHLGVBQWUsQ0FBQztBQUM1RCxDQUFDO0FBRUQsTUFBTSxVQUFVLG1CQUFtQixDQUFDLGFBQWdDLEVBQUUsUUFBUSxHQUFDLEtBQUssRUFDaEQsV0FBK0IsRUFBRSxVQUE2QixFQUM5RCxTQUErQztJQUNqRixNQUFNLHNCQUFzQixHQUFHLHlCQUF5QixDQUFDLGFBQWEsQ0FBQyxDQUFDO0lBQ3hFLElBQUksQ0FBQyxzQkFBc0I7UUFBRSxPQUFPLElBQUksQ0FBQztJQUN6QyxNQUFNLE9BQU8sR0FBRyxDQUFDLG9CQUFDLHNCQUFzQixJQUFDLEdBQUcsRUFBRSxhQUFhLENBQUMsRUFBRSxFQUFFLEtBQUssRUFBRSxhQUFhLEVBQUUsUUFBUSxFQUFFLFFBQVEsRUFDdEYsV0FBVyxFQUFFLFdBQVcsRUFBRSxVQUFVLEVBQUUsVUFBVSxFQUFFLFNBQVMsRUFBRSxTQUFTLEdBQUcsQ0FBQyxDQUFDO0lBQzdGLElBQUksYUFBYSxDQUFDLE9BQU8sRUFBRSxDQUFDO1FBQzFCLE9BQU8sT0FBTyxDQUFDO0lBQ2pCLENBQUM7U0FBTSxDQUFDO1FBQ04sNkRBQTZEO1FBQzdELE9BQU8sQ0FBQywyQkFBRyxHQUFHLEVBQUUsYUFBYSxDQUFDLEVBQUUsRUFBRSxTQUFTLEVBQUMsT0FBTyxJQUFFLE9BQU8sQ0FBSyxDQUFDLENBQUM7SUFDckUsQ0FBQztBQUNILENBQUM7QUFFRCxNQUFNLENBQUMsTUFBTSxxQkFBcUIsR0FBRyxLQUFLLENBQUMsSUFBSSxDQUF1QixHQUFHLEVBQUU7SUFDekUsTUFBTSxtQkFBbUIsR0FBRyxNQUFNLENBQUMsTUFBTSxDQUFDLG1CQUFtQixDQUFDLENBQUMsR0FBRyxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsSUFBSyxDQUFDLFVBQVUsQ0FBQyxDQUFDO0lBQzdGLE9BQU8sS0FBSyxDQUFDLEtBQUssQ0FBQyxHQUFHLG1CQUFtQixDQUF5QixDQUFDO0FBQ3JFLENBQUMsQ0FBQyxDQUFDIn0=